module.exports = __webpack_public_path__ + "img/kids-forest-fade-sm-1x.1fab4edf.jpg";